<ng-template #defaultTabButtons let-c="close" let-d="dismiss">
    <!-- <div class="modal-body text-white backgroundTable">
        <div class="row ">
                <div class="col-9 bd-highlight">
                    <h6 class="mt-2 ms-3">Editar Usuario</h6>
                </div>
                <div class="col-3 d-flex flex-row-reverse bd-highlight"><button type="button" ngbAutofocus
                        aria-label="Close" (click)="d('Cross click')" class="btn btn-outline-danger">Cerrar</button>
                </div>
        </div>
        
        <div class="p-3 row mt-3" >
            <form
                action=""
                method="post"
                (submit)="formSubmit()"
                [formGroup]="popForm">
            <br>
            <div class="col-12">
                <label for="formControlInput" class="form-label ">Rol</label>
                <select required class="custom-outline-input form-control" id="dependenceId" formControlName="type_id" >
                <option selected value="">Seleccione una dependencia</option>
                <option *ngFor="let item of listType" [value]="item.id">
                  {{item.name}}
                </option>
              </select>
            </div>
            <div class="col-12">
                    <label for="formControlInput" class="form-label">Fecha inicio</label>
                    <input required type="date" class="custom-outline-input form-control date" formControlName="start_date" id="formControlInput">
            </div>
            <div class="col-12">
                    <label for="formControlInput" class="form-label">Fecha termino</label>
                    <input required type="date" class="custom-outline-input form-control date" formControlName="end_date" id="formControlInput">
            </div>
            <div class="col-12">
                    <label for="formControlInput" class="form-label">% de asignación</label>
                    <input required type="text" placeholder="Ingrese información" formControlName="assigned" class="custom-outline-input form-control" id="formControlInput">
            </div>
            <br>
            <div class="col-12 mt-3 d-flex justify-content-center">
                <button class="btn btn-outline-light " [disabled]="!popForm.valid" >Guardar</button>
            </div>
            </form>
        </div>
    </div> -->

    <div class="text-white backgroundTable">

        <div class="mx-5">
            <div class="row my-2">
              <div class="col-9 align-self-center p-2 bd-highlight">
                Editar Usuario
              </div>
      
              <div class="col-3 d-flex flex-row-reverse bd-highlight p-2">
                <button
                  type="button"
                  ngbAutofocus
                  aria-label="Close"
                  (click)="d('Cross click')"
                  class="btn btn-outline-danger"
                >
                  <i class="fa-solid fa-xmark fa-xl"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="componente-importantes-from-popup p-4">
            <form
              action=""
              method="post"
              (submit)="formSubmit()"
              [formGroup]="popForm"
            >
              <br />
              <div class="col-12">
                <label for="formControlInput" class="form-label">Rol</label>
                <select
                  required
                  class="custom-outline-input form-control"
                  id="dependenceId"
                  formControlName="type_id"
                >
                  <option selected value="">Seleccione una dependencia</option>
                  <option *ngFor="let item of listType" [value]="item.id">
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div class="col-12">
                <label for="formControlInput" class="form-label"
                  >Fecha inicio</label
                >
                <input
                  required
                  type="date"
                  class="custom-outline-input form-control date"
                  formControlName="start_date"
                  id="start_date"
                />
              </div>
              <div class="col-12">
                <label for="formControlInput" class="form-label"
                  >Fecha termino</label
                >
                <input
                  required
                  type="date"
                  class="custom-outline-input form-control date"
                  formControlName="end_date"
                  id="end_date"
                />
              </div>
              <div class="col-12">
                <label for="formControlInput" class="form-label"
                  >% de asignación</label
                >
                <input
                  required
                  type="text"
                  placeholder="Ingrese información"
                  formControlName="assigned"
                  class="custom-outline-input form-control"
                  id="formControlInput"
                />
              </div>
              <br />
              <div class="">
                <div class="col-12 mt-3 d-flex justify-content-center " >
                    <button class="btn btn-outline-light" [disabled]="!popForm.valid">
                      Guardar
                    </button>
                  </div>
              </div>
    
            </form>
          </div> 

    </div>

</ng-template>